<template>
  <div>
    <main-layout>
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Link Copied') }}!</v-snackbar
      >
      <v-container>
        <v-layout v-if="isZwizAdmin()" class="mb-5">
          <v-flex>
            <div style="margin-top: 10px">{{ $t('Activate bot') }}</div>
            <div class="red--text">
              ***
              {{ $t('Information will not be recorded in analytics if the bot is inactivated2') }}
            </div>
          </v-flex>
          <v-flex shrink>
            <label
              class="toggle-switch small"
              style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
            >
              <input type="checkbox" :checked="botStatus" @change="toggleBotStatus()" />
              <span class="toggle-slider lever round"></span>
            </label>
          </v-flex>
        </v-layout>
        <div
          v-if="selectedBot.status"
          class="hr"
          style="margin-top: 20px; border-color: rgba(0, 0, 0, 0.12)"
        ></div>
        <div
          v-if="selectedBot.status"
          class="text-xs-center"
          style="margin: -13px; margin-bottom: 10px"
        >
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            style="position: relative"
            @click="onOffbotToggle = !onOffbotToggle"
          >
            <em
              class="fa"
              :class="{ 'fa-angle-down': !onOffbotToggle, 'fa-angle-up': onOffbotToggle }"
            />
          </a>
        </div>

        <template v-if="onOffbotToggle">
          <v-layout wrap row>
            <v-flex xs8>
              <div class="pl-2 pt-3">{{ $t('activate_facebook') }}</div>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <div class="pt-2">
                <toggle-button
                  class="mt-2"
                  :value="toggleFacebook"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                  @change="onChangeToggleClosePlatFrom('facebook')"
                />
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap row>
            <v-flex xs8>
              <div class="pl-2 pt-3">{{ $t('activate_line') }}</div>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <div class="pt-2">
                <toggle-button
                  class="mt-2"
                  :value="toggleLine"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                  @change="onChangeToggleClosePlatFrom('line')"
                />
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap row>
            <v-flex xs8>
              <div class="pl-2 pt-3">{{ $t('activate_instagram') }}</div>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <div class="pt-2">
                <toggle-button
                  class="mt-2"
                  :value="toggleIg"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                  @change="onChangeToggleClosePlatFrom('ig')"
                />
              </div>
            </v-flex>
          </v-layout>
          <v-divider class="my-3" />
        </template>

        <div
          v-if="
            ['studio7', 'ustore', 'ticket2', 'toa'].includes(selectedBot.theme) && !loadingSetting
          "
        >
          <Ticket2AdminDefaultMessage></Ticket2AdminDefaultMessage>
        </div>
        <div v-if="['tdtawandang'].includes(selectedBot.theme) && !loadingSetting">
          <TDAdminDefaultMessage></TDAdminDefaultMessage>
        </div>

        <template v-if="selectedBot && selectedBot.type === 'gpf'">
          <gpf-setting-bot v-if="botStatus"></gpf-setting-bot>
        </template>
        <div v-else class="row">
          <div class="col s12">
            <manage-open-time-bot v-if="botStatus"></manage-open-time-bot>
          </div>
        </div>
      </v-container>
      <v-divider></v-divider>
      <div class="container">
        <div class="row">
          <div class="col s8">
            <div style="margin-top: 10px">
              {{ $t('Disallowing a bot to reply repeated questions') }}
            </div>
          </div>
          <div class="col s4 right-align">
            <label
              class="toggle-switch small"
              style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
            >
              <input type="checkbox" :checked="pauseStatus" @change="togglePauseStatus()" />
              <span class="toggle-slider lever round"></span>
            </label>
          </div>
          <div class="col s12" style="margin-top: 10px">
            <label for>{{
              $t('* Note: Affect only for Conversation Page (not include Reply to Comment Page)')
            }}</label>
          </div>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="container">
        <div class="row">
          <div class="col s9">{{ $t('Typing Time') }}</div>
          <div class="col s3 right-align">
            <div
              v-if="!isEditDelay"
              class="btn-floating btn-outline-red text-xs-center"
              style="margin-left: 5px; margin-bottom: 5px"
              @click="isEditDelay = true"
            >
              <em class="fa fa-pencil-alt middle" />
            </div>
          </div>
          <div class="col s12">
            <h5>{{ delayMessageTime }}s</h5>
            <label for>{{
              $t(
                'User can set the typing time for Bot to reply, and it will apply to all conversation.'
              )
            }}</label>
          </div>
          <div v-if="isEditDelay" class="col s12">
            <v-slider
              v-model="delayMessageTime"
              :color="$vuetify.theme.primary"
              ticks
              always-dirty
              min="0"
              max="10"
              step="0.5"
              thumb-label
              @change="onChangeDelayMessage"
            >
              <template #prepend>
                <a href="javascript:void(0)" @click="decrementDelayMessage">
                  <span class="fas fa-minus"></span>
                </a>
              </template>

              <template #append>
                <a href="javascript:void(0)" @click="incrementDelayMessage">
                  <span class="fas fa-plus"></span>
                </a>
              </template>
            </v-slider>

            <div class="text-xs-center">
              <a
                href="javascript:void(0)"
                class="btn btn-outline-gray"
                @click="onCancelEditDelayMessage"
                >{{ $t('cancel') }}</a
              >
              <a href="javascript:void(0)" class="btn" @click="onSaveEditDelayMessage">{{
                $t('Save')
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <v-divider></v-divider>
      <AdminHandOver
        v-if="!loadingSetting && !['scgdistribution'].includes(selectedBot.theme)"
      ></AdminHandOver>

      <v-divider></v-divider>
      <SettingDeleteUser v-if="isAiraAifulPage"></SettingDeleteUser>
      <v-divider></v-divider>

      <div class="container">
        <div class="row">
          <div class="col s12">
            <h5>
              {{ $t('Line Notify') }}
              <a
                href="https://blog.zwiz.ai/line-notify-%E0%B9%81%E0%B8%88%E0%B9%89%E0%B8%87%E0%B9%80%E0%B8%95%E0%B8%B7%E0%B8%AD%E0%B8%99%E0%B8%9C%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B9%84%E0%B8%A5%E0%B8%99%E0%B9%8C/"
              >
                <em style="font-size: 20px" class="fas fa-question-circle" />
              </a>
            </h5>
          </div>
        </div>
        <div v-if="loadingLineNotify" class="text-xs-center"></div>
        <div
          v-else
          style="position: relative; padding: 10px 0px"
          :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '174px' : '0px' }"
        >
          <v-premium-plan-popup
            v-if="$store.getters.getPackage != 'premium'"
            :show-all="false"
            style="border-radius: 10px"
          ></v-premium-plan-popup>
          <div v-if="!isLinkedLineNotify" class="row">
            <div class="col s5 m8">{{ $t('Not connect to the account') }}</div>
            <div class="col s7 m4 right-align">
              <template v-if="$store.getters.getPackage == 'premium'">
                <a :href="lineNotifyLink" class="btn btn-outline-red">{{ $t('Link Account') }}</a>
              </template>
              <template v-else>
                <a href="javascript:void(0);" class="btn btn-outline-red">{{
                  $t('Link Account')
                }}</a>
              </template>
            </div>
          </div>
          <div class="row">
            <div
              v-for="(person, index) in linenotifylist"
              :key="'line_' + index"
              class="col s12"
              style="margin-bottom: 10px"
            >
              <div class="z-border-red">
                <div class="row" style="margin-bottom: 0">
                  <div class="col s8" style="padding: 10px 20px">
                    <img
                      :src="'https://graph.facebook.com/' + person.adminid + '/picture?type=square'"
                      width="50"
                      height="50"
                      :alt="person.name"
                      style="border-radius: 50%; margin-right: 10px; float: left"
                      @error="onFailLoad"
                    />
                    <div style="margin-top: 13px">{{ person.name }}</div>
                  </div>
                  <div
                    v-if="person.adminid == $store.state.userid || getBotPageRole == true"
                    class="col s4 right-align"
                    style="padding: 10px 20px"
                  >
                    <a
                      href="javascript:void(0)"
                      class="btn btn-outline-red btn-floating btn-small"
                      @click="deleteLineNotify(person)"
                    >
                      <span class="fas fa-trash-alt"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="linenotifylist && linenotifylist.length > 0" class="pa-2">
            <h5>{{ $t('Notification Settings') }}</h5>

            <v-layout wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-2">{{ $t('All conversation') }}</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <label class="toggle-switch small" style="margin-top: 10px; vertical-align: bottom">
                  <input
                    type="checkbox"
                    :checked="linenotify.notify_intent"
                    @change="onChangeLineNotify('notify_intent')"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
            </v-layout>

            <transition name="fade">
              <v-layout v-if="linenotify.notify_intent" wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Selected conversation') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="pt-2">
                    <a href="#" @click="showEditLineNotifyConversation = true">{{ $t('edit') }}</a>
                  </div>
                </v-flex>
              </v-layout>
            </transition>

            <v-layout wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-2">{{ $t('All Comments') }}</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <label class="toggle-switch small" style="margin-top: 10px; vertical-align: bottom">
                  <input
                    type="checkbox"
                    :checked="linenotify.notify_comment"
                    @change="onChangeLineNotify('notify_comment')"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
            </v-layout>

            <transition name="fade">
              <v-layout v-if="linenotify.notify_comment" wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Selected comment') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="pt-2">
                    <a href="#" @click="showEditLineNotifyReplyComment = true">{{ $t('edit') }}</a>
                  </div>
                </v-flex>
              </v-layout>
            </transition>

            <template v-if="$store.state.shoptheme.includes(selectedBot.theme)">
              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Notify when customer ordered') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_neworder"
                      @change="onChangeLineNotify('notify_neworder')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>

              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Notify when customer paid') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_payment"
                      @change="onChangeLineNotify('notify_payment')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>
              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('Notify when token expired') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_token_expired"
                      @change="onChangeLineNotify('notify_token_expired')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>
            </template>
            <manage-single-line-notify
              v-if="showEditLineNotifyConversation"
              @close="showEditLineNotifyConversation = false"
            ></manage-single-line-notify>

            <manage-single-line-notify
              v-if="showEditLineNotifyReplyComment"
              type="replycomment"
              @close="showEditLineNotifyReplyComment = false"
            ></manage-single-line-notify>
          </div>
        </div>
      </div>

      <!-- <v-divider></v-divider>
      <div class="pb-4 text-xs-center">
        <v-container>
          <h4>{{$t('Support2')}}</h4>
          <support-code @updateSupportCode="onUpdateSupportCode"></support-code>
        </v-container>
      </div>-->

      <v-divider></v-divider>

      <template v-if="!['scgdistribution'].includes(selectedBot.theme)">
        <div id="_line" style="position: relative">
          <div class="container">
            <div class="row">
              <div class="col s9">
                <h5>Line Chatbot</h5>
              </div>
              <div class="col s3 right-align">
                <div
                  v-if="!isEditLine && $store.getters.getPackage == 'premium'"
                  class="btn-floating btn-outline-red text-xs-center"
                  style="margin-left: 5px; margin-bottom: 5px"
                  @click="isEditLine = true"
                >
                  <em class="fa fa-pencil-alt middle" />
                </div>
              </div>
              <div
                class="col s12"
                style="position: relative; padding-top: 15px; padding-bottom: 15px"
              >
                <v-premium-plan-popup
                  v-if="$store.getters.getPackage != 'premium'"
                  :show-all="false"
                  margin-top="65"
                  style="border-radius: 10px"
                ></v-premium-plan-popup>
                <ul class="list-group vertical-steps">
                  <li class="list-group-item">
                    <div class="form-control">
                      <label for>Webhook Url</label>
                      <div class="row" style="margin-bottom: 0">
                        <div class="col s12 m9">
                          <textarea
                            ref="shareLink"
                            v-model="webhookUrl"
                            class="form-control"
                            style="resize: vertical; min-height: 90px; background: #eee"
                            onclick="this.select()"
                            readonly="true"
                          ></textarea>
                        </div>
                        <div class="left-align col s12 m3">
                          <a
                            v-clipboard:copy="webhookUrl"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                            href="javascript:void(0);"
                            class="btn btn-outline-red"
                            style="position: relative"
                          >
                            <span class="fas fa-copy"></span>
                            {{ $t('copy') }}
                            <transition
                              enter-active-class="animated fadeInUp"
                              leave-active-class="animated fadeOut"
                            ></transition>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="form-control">
                      <label for="text">{{ $t('Access Token') }}</label>
                      <div v-if="isEditLine">
                        <textarea
                          v-model="line.line_access_token"
                          class="form-control"
                          rows="5"
                          maxlength="600"
                          style="resize: vertical; min-height: 90px"
                          :placeholder="'Access Token'"
                        ></textarea>
                      </div>
                      <div v-else>
                        <h6 style="word-break: break-all">
                          {{ line.line_access_token ? line.line_access_token : '-' }}
                        </h6>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="form-control">
                      <label for="text">{{ $t('Channel Secret') }}</label>
                      <div v-if="isEditLine">
                        <textarea
                          v-model="line.line_channel_secret"
                          class="form-control"
                          rows="5"
                          maxlength="600"
                          style="resize: vertical; min-height: 90px"
                          :placeholder="'Channel Secret'"
                        ></textarea>
                      </div>
                      <div v-else>
                        <h6 style="word-break: break-all">
                          {{ line.line_channel_secret ? line.line_channel_secret : '-' }}
                        </h6>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="form-control">
                      <label for="text">{{ $t('Channel ID') }}</label>
                      <div v-if="isEditLine">
                        <textarea
                          v-model="line.line_channel_id"
                          class="form-control"
                          rows="5"
                          maxlength="600"
                          style="resize: vertical; min-height: 90px"
                          :placeholder="'Channel ID'"
                        ></textarea>
                      </div>
                      <div v-else>
                        <h6 style="word-break: break-all">
                          {{ line.line_channel_id ? line.line_channel_id : '-' }}
                        </h6>
                      </div>
                    </div>
                  </li>
                </ul>

                <div v-if="isEditLine" class="text-xs-center" style="margin-top: 15px">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-outline-gray"
                    @click="cancelEditLine"
                    >{{ $t('cancel') }}</a
                  >
                  <a href="javascript:void(0);" class="btn" @click="saveEditLine">{{
                    $t('Save')
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-divider />
        <v-container>
          <SocialConnect></SocialConnect>
        </v-container>

        <ConnectAccount />

        <v-container>
          <v-layout wrap>
            <v-flex xs6>Bot id</v-flex>
            <v-flex xs6
              >{{ selectedBot.pageid }}
              <v-btn
                v-clipboard:copy="selectedBot.pageid"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                small
                fab
                flat
                color="primary"
              >
                <v-icon>content_copy</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <template v-if="selectedBot.pagetype !== 'enterprise'">
        <v-divider></v-divider>
        <v-container>
          <h5>{{ $t('Integrated Partner') }}</h5>
          <chatday></chatday>
        </v-container>
      </template>
      <template
        v-if="selectedBot.theme == 'ecommercebasic' && selectedBot.pagetype !== 'enterprise'"
      >
        <v-divider class="my-3"></v-divider>
        <v-container>
          <ketshop-setting></ketshop-setting>
        </v-container>
      </template>
      <template
        v-if="
          selectedBot &&
          selectedBot.hasOwnProperty('synctagsfacebook_status') &&
          selectedBot.pagetype != 'enterprise'
        "
      >
        <v-divider />
        <facebook-tags></facebook-tags>
      </template>

      <v-divider></v-divider>
      <div v-if="!['100707492390105'].includes(selectedBot.pageid)" class="container">
        <div class="row">
          <div class="col s5">{{ $t('remove bot') }}</div>
          <div class="col s7 right-align">
            <a href="javascript:void(0);" class="btn btn-outline-red" @click="onUnsubscribeBot">{{
              $t('remove bot')
            }}</a>
          </div>
        </div>
      </div>
      <div class="my-5"></div>
    </main-layout>
  </div>
</template>

<script>
import api from '@/api'
import ConnectAccount from '@/components/view/customAudience/ConnectAccount.vue'
import ViewPackage from '@/components/view/setting/ViewPackage'
import config from '@/config'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import AdminHandOver from './adminHandOver.vue'
import Chatday from './Chatday'
import FacebookTags from './FacebookTags'
import GpfSettingBot from './GpfSettingBot'
import KetshopSetting from './KetshopSetting'
import ManageOpenTimeBot from './ManageOpenTimeBot'
import ManageSingleLineNotify from './ManageSingleLineNotify'
import SettingDeleteUser from './SettingDeleteUser.vue'
import SocialConnect from './SocialConnect'
import SupportCode from './SupportCode'
import TDAdminDefaultMessage from './TDAdminDefaultMessage'
import Ticket2AdminDefaultMessage from './Ticket2AdminDefaultMessage'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    ToggleButton,
    ViewPackage,
    ManageSingleLineNotify,
    SupportCode,
    ManageOpenTimeBot,
    KetshopSetting,
    AdminHandOver,
    SettingDeleteUser,
    Chatday,
    FacebookTags,
    Ticket2AdminDefaultMessage,
    TDAdminDefaultMessage,
    SocialConnect,
    ConnectAccount,
    GpfSettingBot
  },
  data: function () {
    return {
      onOffbotToggle: false,
      toggleLine: false,
      toggleIg: false,
      toggleFacebook: false,
      expriedDate: null,
      expriedTime: null,
      isEdit: false,
      botStatus: false,
      pauseStatus: false,
      isEditLine: false,
      line: {
        line_access_token: null,
        line_channel_secret: null,
        line_channel_id: null
      },
      showCopy: false,
      delayMessageTime: 0,
      isEditDelay: false,
      loadingLineNotify: true,
      linenotifylist: [],
      showEditLineNotifyConversation: false,
      showEditLineNotifyReplyComment: false,
      linenotify: {
        notify_comment: false,
        notify_intent: false,
        notify_neworder: false,
        notify_payment: false,
        notify_token_expired: false
      },
      loadingFacebookPay: true,
      facebookPayStatus: false
    }
  },
  watch: {
    selectedBotStatus() {
      let vm = this
      vm.botStatus = vm.selectedBot.status
    }
  },
  mounted: async function () {
    var vm = this
    vm.toggleLine = vm.selectedBot.line_status
    vm.toggleIg = vm.selectedBot.instagram_status
    vm.toggleFacebook = vm.selectedBot.facebook_status
    vm.botStatus = vm.selectedBot.status
    vm.loadingLineNotify = true
    vm.$store.dispatch('loadSetting')
    try {
      var response = await vm.$store.dispatch('updateBotDetail')
      vm.linenotify = {
        notify_comment: vm.selectedBot.notify_comment,
        notify_intent: vm.selectedBot.notify_intent,
        notify_neworder: vm.selectedBot.notify_neworder,
        notify_payment: vm.selectedBot.notify_payment,
        notify_token_expired: vm.selectedBot.notify_token_expired
      }
    } catch (error) {}

    await vm.getPauseStatus()
    vm.loadingLineNotify = false

    vm.getLineNotify()
    await vm.getLineToken()

    vm.cached_line = JSON.stringify(vm.line)
    if (!vm.line.line_access_token || !vm.line.line_channel_secret) {
      vm.isEditLine = true
    }
    if (vm.$route.query.go === 'line') {
      $('.vb-content').animate({
        scrollTop: $(window).height() - $('#_line').height()
      })
    }

    await vm.getDelayMessage()
    vm.cached_delay_message_time = vm.delayMessageTime

    this.loadingFacebookPay = true
    var response = await this.getFacebookPayStatus()
    if (response.status) {
      this.facebookPayStatus = response.status
    }
    this.loadingFacebookPay = false
  },
  computed: {
    selectedBotStatus() {
      return this.selectedBot.status
    },
    ...mapGetters({
      botlist: 'botlist',
      allPage: 'allPage',
      currentLang: 'currentLang',
      selectedBot: 'selectedBot',
      loadingSetting: 'getLoadingSetting'
    }),
    getBotPageRole: function () {
      var vm = this
      var bot = vm.allPage.find(function (val, index) {
        return val.id == vm.selectedBot.pageid
      })
      if (bot) {
        if (bot.perms) {
          return bot.perms.indexOf('ADMINISTER') > -1
        } else if (bot.tasks) {
          return bot.tasks.indexOf('MANAGE') > -1
        }
      } else {
        return null
      }
    },
    isLinkedLineNotify: function () {
      var vm = this
      if (!vm.selectedBot) {
        return false
      }
      return (
        vm.linenotifylist.findIndex(function (el) {
          return el.pageid == vm.selectedBot.pageid && el.adminid == vm.$store.state.userid
        }) > -1
      )
    },
    lineNotifyLink: function () {
      return (
        'https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=vf6yxOil8ZhEDPxgKtZd6c&redirect_uri=' +
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        '/linenotify&scope=notify&state=zwizai'
      )
    },
    selectedBot: {
      get() {
        if (this.$store.state.selectedBot == null) {
          return null
        }
        var now = moment()
        var expriedDate = moment(this.$store.state.selectedBot.expireat)
        this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
        this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
        return this.$store.state.selectedBot
      },
      set(bot) {
        let vm = this
        vm.currentBot = bot
        vm.$store.dispatch('selectBot', vm.currentBot)
        location.reload()
      }
    },
    webhookUrl: function () {
      return config.serverUrl + 'webhookline?facebookpageid=' + this.selectedBot.pageid
    },
    isAiraAifulPage() {
      return PAGE.AIRA_AIFUL.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    async onChangeToggleClosePlatFrom(platfrom) {
      const vm = this
      let bodyData = vm.togglePlatform(platfrom)
      vm.$store.dispatch('loading')
      var data = {
        body: bodyData,
        pageid: vm.selectedBot.pageid
      }
      var res = await api.updatePageConfig(data)
      if (res.success) {
      } else {
        vm.togglePlatform(platfrom)
      }
      vm.$store.dispatch('loading')
    },
    togglePlatform(platfrom) {
      let vm = this
      if (platfrom === 'facebook') {
        vm.toggleFacebook = !vm.toggleFacebook
        return { facebook_status: vm.toggleFacebook }
      } else if (platfrom === 'line') {
        vm.toggleLine = !vm.toggleLine
        return { line_status: vm.toggleLine }
      } else if (platfrom === 'ig') {
        vm.toggleIg = !vm.toggleIg
        return { instagram_status: vm.toggleIg }
      } else {
        return {}
      }
    },
    getFacebookPayStatus() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve) => {
        api.getFacebookPayStatus(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          resolve(response)
        })
      })
    },
    onUpdateSupportCode: function () {
      location.reload()
    },
    onChangeLineNotify: function (type) {
      this.linenotify[type] = !this.linenotify[type]
      var data = this.linenotify
      data.pageid = this.selectedBot.pageid
      api.saveLineNotifyNotification(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    onFailLoad: function () {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    deleteLineNotify: function (person) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to unlink this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteLineNotify(
              { pageid: person.pageid, adminid: person.adminid },
              function (error, response) {
                if (error) {
                  // reject(error)
                }
                var deleteIndex = vm.linenotifylist.findIndex(function (el) {
                  return el.pageid == person.pageid && el.adminid == person.adminid
                })
                if (deleteIndex > -1) {
                  vm.linenotifylist.splice(deleteIndex, 1)
                }
                vm.$store.dispatch('loading')
                // resolve()
              }
            )
          }
        })
    },
    getDelayMessage: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getReplyDelay({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.delayMessageTime = response.data.replydelay / 1000
          resolve()
        })
      })
    },
    onCancelEditDelayMessage: function () {
      var vm = this
      vm.delayMessageTime = vm.cached_delay_message_time
      vm.isEditDelay = false
    },
    onSaveEditDelayMessage: function () {
      var vm = this
      vm.$store.dispatch('loading')
      return new Promise((resolve, reject) => {
        api.editReplyDelay(
          { pageid: vm.selectedBot.pageid, replydelay: vm.delayMessageTime * 1000 },
          function (error, response) {
            if (error) {
              reject(error)
              vm.$store.dispatch('loading')
            }
            vm.cached_delay_message_time = vm.delayMessageTime
            vm.isEditDelay = false
            vm.$store.dispatch('loading')
            resolve()
          }
        )
      })
    },
    decrementDelayMessage() {
      this.delayMessageTime -= 0.5
    },
    incrementDelayMessage() {
      this.delayMessageTime += 0.5
    },
    onChangeDelayMessage: function () {},
    getPauseStatus: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getPauseStatus({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.pauseStatus = response.data.notreplyduplicateintent === true
          resolve()
        })
      })
    },
    cancelEditLine: function () {
      var vm = this
      vm.line = JSON.parse(vm.cached_line)
      vm.isEditLine = false
    },
    saveEditLine: function () {
      var vm = this
      if (vm.$store.getters.getPackage !== 'premium') {
        vm.line = JSON.parse(vm.cached_line)
        vm.isEditLine = false
        return
      }
      vm.$store.dispatch('loading')
      api.saveLineToken(
        {
          pageid: vm.selectedBot.pageid,
          line_access_token: vm.line.line_access_token ? vm.line.line_access_token.trim() : '',
          line_channel_secret: vm.line.line_channel_secret
            ? vm.line.line_channel_secret.trim()
            : '',
          line_channel_id: vm.line.line_channel_id ? vm.line.line_channel_id.trim() : ''
        },
        function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')
          }
          vm.cached_line = JSON.stringify(vm.line)
          vm.isEditLine = false
          vm.$store.dispatch('loading')
          location.reload()
        }
      )
    },
    getLineToken: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineToken({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
            vm.$store.dispatch('loading')
          }
          vm.line = {
            line_access_token: response.data.line_access_token,
            line_channel_secret: response.data.line_channel_secret,
            line_channel_id: response.data.line_channel_id
          }
          resolve()
        })
      })
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
    onUnsubscribeBot: function () {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Unsubscribe this?'),
          text: vm.$t('Warning!! If you unsubscribe this, Bot data will be lost'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          footer: vm.$t('If you want any help, please contact via E-mail: sales@zwiz.ai')
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            let bot = vm.selectedBot
            api.unSubscribe(bot, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              let newbotlist = vm.botlist
              $.each(newbotlist, function (index, oldbot) {
                if (bot.pageid == oldbot.pageid) {
                  newbotlist.splice(index, 1)
                  return false
                }
              })

              vm.$store.dispatch('unselectBot')
              vm.$store.dispatch('updateBotlist', newbotlist)
              vm.$store.dispatch('updatePagelist')
              vm.$store.dispatch('loading')
              vm.$router.push('/' + vm.currentLang + '/allbots')
            })
          }
        })
    },
    toggleBotStatus: function () {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status
      let data = {
        theme: bot.theme,
        page_access_token: bot.page_access_token,
        pageid: bot.pageid,
        status: bot.status
      }
      vm.$store.dispatch('loading')
      api.toggleBotStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function (index, oldbot) {
          if (bot.pageid === oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    },
    togglePauseStatus: function () {
      let vm = this
      vm.pauseStatus = !vm.pauseStatus
      var data = {
        pageid: vm.selectedBot.pageid,
        notreplyduplicateintent: vm.pauseStatus
      }

      vm.$store.dispatch('loading')
      api.togglePauseStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.selectedBot.notreplyduplicateintent = vm.pauseStatus
        vm.$store.dispatch('loading')
      })
    },
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    onCopyError: function () {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Billing.vue